var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.991,
    height: 35.991,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-pickup",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M87.5,949h-38A10.511,10.511,0,0,1,39,938.5v-34a2.482,2.482,0,0,1,.56-1.579l9.79-12a2.511,2.511,0,0,1,1.94-.92H85.7a2.51,2.51,0,0,1,1.94.92l9.79,12A2.5,2.5,0,0,1,98,904.5v34A10.511,10.511,0,0,1,87.5,949ZM65.464,921.257v14.98a3,3,0,0,0,6,0v-15l4.881,4.88a3,3,0,1,0,4.24-4.24l-10-10a3,3,0,0,0-4.241,0l-10,10a3,3,0,0,0,4.24,4.24l4.879-4.858ZM52.48,895l-5.72,7H90.2l-5.72-7Z",
    transform: "translate(-39 -890)",
    fill: "#fafafa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPickup);
export default __webpack_public_path__ + "static/media/icon-pickup.30f9b022de823c977f3c593a2f5e6215.svg";
export { ForwardRef as ReactComponent };